import Hls, { ErrorDetails as HlsErrorDetails, ErrorData as HlsErrorData, ErrorTypes } from 'hls.js';
import clientFacingHlsProvider from '../utils/client-facing-hls';
import EventBus, { Event } from '../../event-bus';
import { CONTEXT, emitToClient } from '.';

const PLAYBACK_FATAL_TIMEOUT = 10 * 1000;

export const SMVP_ERROR = 'smvpError';

declare enum SmvpError {
    SMVP_ERROR = 'smvpError',
}

export type ErrorDetails = HlsErrorDetails | SmvpError

export interface ErrorData extends Omit<HlsErrorData, 'details'> {
    details: ErrorDetails;
}

export default class SmvpErrorHandler {

    private smvpErrorTimeout: number | undefined = undefined;

    constructor(
        private hls: Hls,
        private eventBus: EventBus) {
    }

    public startFatalTimeoutHandler(event: string, data: ErrorData) {
        if (this.smvpErrorTimeout) return;

        this.smvpErrorTimeout = setTimeout(() => {
            console.debug('[SmvpErrorHandler] fatal timeout callback');
            this.smvpErrorTimeout = undefined;
            this.smvpFatalEmit(event, data);
        }, PLAYBACK_FATAL_TIMEOUT);
    }

    public smvpFatalEmit(event: string, data: ErrorData) {
        data.fatal = true;
        data.details = SMVP_ERROR as ErrorDetails;
        emitToClient(this.hls, this.eventBus, event, data);
    }

    public stopFatalTimeoutHandler() {
        console.debug('[SmvpErrorHandler] stopping fatal timeout');
        clearTimeout(this.smvpErrorTimeout);
        this.smvpErrorTimeout = undefined;
    }

    public playbackLoadingErrorHandler(
        shouldShowLoading: boolean
    ) {
        if (!shouldShowLoading) {
            this.stopFatalTimeoutHandler();
            return this.eventBus.emit(Event.customAction, {
                hls: clientFacingHlsProvider(this.hls),
                event: 'smvpErrorRecover',
                data: {
                    shouldShowLoading
                }
            }, CONTEXT);
        } else {
            console.debug('[SmvpErrorHandler] starting fatal timeout on playbackLoadingErrorHandler', { shouldShowLoading });
            this.startFatalTimeoutHandler('loadingNotification', {
                type: 'otherError' as ErrorTypes,
                details: SMVP_ERROR as ErrorDetails,
                fatal: false,
                error: new Error('playbackLoadingErrorHandler')
            });
        }
    }

}
